import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/App.css";

// Layout Components
import Layout from "./components/Layout/Layout";
import ProtectedRoute from "./components/Common/ProtectedRoute";

// Auth Pages
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";

// Main Pages
import Dashboard from "./pages/Dashboard/Dashboard";
import Members from "./pages/Members/Members";
import AddMember from "./pages/Members/AddMember";
import EditMember from "./pages/Members/EditMember";
import MemberReport from "./pages/Members/MemberReport";
import Plans from "./pages/Membership/Plans";
import AddPlan from "./pages/Membership/AddPlan";
import Payments from "./pages/Payments/Payments";
import SubscriptionTypes from "./pages/Settings/SubscriptionTypes";
import EditPlan from "./pages/Membership/EditPlan";
import PlanDetails from "./pages/Membership/PlanDetails";
import MemberDetails from "./pages/Members/MemberDetails";
import ExpiryReport from "./pages/Members/ExpiryReport";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/members" element={<Members />} />
            <Route path="/members/add" element={<AddMember />} />
            <Route path="/members/edit/:id" element={<EditMember />} />
            <Route path="/members/report" element={<MemberReport />} />
            <Route path="/members/expiry/report" element={<ExpiryReport />} />
            <Route path="/membership/plans" element={<Plans />} />
            <Route path="/membership/plans/add" element={<AddPlan />} />
            <Route path="/members/view/:id" element={<MemberDetails />} />
            {/* <Route path="/membership/plans/edit" element={<EditPlan />} /> */}
            <Route path="/membership/plans/:id" element={<PlanDetails />} />
            <Route path="/membership/plans/edit/:id" element={<EditPlan />} />
            <Route path="/payments" element={<Payments />} />
            <Route
              path="/settings/subscription-types"
              element={<SubscriptionTypes />}
            />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
